import React, { useState } from 'react';
import { useDropzone } from 'react-dropzone';
import axios from 'axios';

export const AddText = () => {
    const [file, setFile] = useState(null);
    const [text, setText] = useState('');
    const [textColor, setTextColor] = useState('#ffffff'); // Default to white
    const [position, setPosition] = useState({ x: 50, y: 50 }); // Default to center
    const [videoPreview, setVideoPreview] = useState('');

    const onDrop = (acceptedFiles) => {
        const uploadedFile = acceptedFiles[0];
        setFile(uploadedFile);
        setVideoPreview(URL.createObjectURL(uploadedFile));
    };

    const handleUpload = async () => {
        if (!file) return alert("Please upload a video file!");
        const formData = new FormData();
        formData.append('video', file);
        formData.append('text', text);
        formData.append('textColor', textColor);
        formData.append('position', JSON.stringify(position));

        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/add-text-video`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
                responseType: 'blob',
            });
           
            
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `edited_video_${Date.now()}.mp4`);
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            console.error("Error uploading video:", error);
        }
    };

    const { getRootProps, getInputProps } = useDropzone({ onDrop, accept: 'video/*' });

    const handlePositionChange = (e) => {
        const { name, value } = e.target;
        setPosition((prev) => ({ ...prev, [name]: value }));
    };

    return (
        <div style={{ textAlign: "center", padding: "20px" }}>
            <h1>Video Editor - Add Text</h1>
            <div {...getRootProps()} style={{ border: '2px dashed #ccc', padding: '20px', textAlign: 'center' }}>
                <input {...getInputProps()} />
                <p>Drag & drop a video file here, or click to select one</p>
            </div>
            {videoPreview && (
                <div style={{ position: 'relative', marginTop: '20px' }}>
                    <h3>Preview:</h3>
                    <div style={{ position: 'relative' }}>
                        <video controls src={videoPreview} style={{ width: '100%', maxHeight: '300px' }}></video>
                        <div
                            style={{
                                position: 'absolute',
                                top: `${position.y}%`,
                                left: `${position.x}%`,
                                transform: 'translate(-50%, -50%)',
                                color: textColor,
                                fontSize: '24px',
                                pointerEvents: 'none',
                            }}
                        >
                            {text}
                        </div>
                    </div>
                </div>
            )}
            <input
                type="text"
                placeholder="Enter text to add to the video"
                value={text}
                onChange={(e) => setText(e.target.value)}
                style={{ marginTop: '20px', display: 'block', width: '100%' }}
            />
            <div style={{ marginTop: '20px' }}>
                <label>
                    Text Color:
                    <input
                        type="color"
                        value={textColor}
                        onChange={(e) => setTextColor(e.target.value)}
                        style={{ marginLeft: '10px' }}
                    />
                </label>
            </div>
            <div style={{ marginTop: '20px' }}>
                <label>
                    X Position:
                    <input
                        type="number"
                        name="x"
                        value={position.x}
                        onChange={handlePositionChange}
                        min="0"
                        max="100"
                        style={{ marginLeft: '10px', width: '50px' }}
                    />
                    %
                </label>
                <label style={{ marginLeft: '20px' }}>
                    Y Position:
                    <input
                        type="number"
                        name="y"
                        value={position.y}
                        onChange={handlePositionChange}
                        min="0"
                        max="100"
                        style={{ marginLeft: '10px', width: '50px' }}
                    />
                    %
                </label>
            </div>
            <button onClick={handleUpload} style={{ marginTop: '20px' }}>
                Upload and Add Text
            </button>
        </div>
    ); 
}
